import { render, staticRenderFns } from "./HomeNewsDetail.vue?vue&type=template&id=8d4f3fe4&scoped=true"
import script from "./HomeNewsDetail.vue?vue&type=script&lang=js"
export * from "./HomeNewsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4f3fe4",
  null
  
)

export default component.exports